export default __webpack_public_path__ + "img/5.asset.ed545a52.jpeg";